import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @author PKr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { Inject } from '@logio/typescript-ioc';
import { WindowPerformanceReportRowDTOConverter, jsonConversions, WindowPerformanceRowsDataDTOConverter, GenericTreeReportHeaderConverter } from '@logio/common-be-fe';
export var WindowPerformanceLayer =
/*#__PURE__*/
function () {
  function WindowPerformanceLayer() {
    _classCallCheck(this, WindowPerformanceLayer);
  }

  _createClass(WindowPerformanceLayer, [{
    key: "createReport",

    /**
     * Creates new window performance report
     * @param filter
     * @returns Promise<WindowReportDTO>
     */
    value: function createReport(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_PERFORMANCE_REPORT).post(filter.toString(), {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Getter for window performance report status
     * @param reportId
     * @returns Promise<IWindowPerformanceReportStatus>
     */

  }, {
    key: "getReportStatus",
    value: function getReportStatus(reportId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_PERFORMANCE_REPORT_STATUS(reportId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  return _this.genericTreeReportHeaderConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Asks BE to return total count of rows in specific report, count should be based on expanded groups.
     * This method is used when AgGrid is initialized in viewport mode.
     * @param reportId
     * @param expandedGroups
     */

  }, {
    key: "getTotalRowCount",
    value: function getTotalRowCount(reportId, expandedGroups) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_WINDOW_PERFORMANCE_REPORT_GET_TOTAL_COUNT(reportId)).post({
                  expandedGroups: expandedGroups
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * Ask BE to return subset of data for grid rows. Rows are specific to specific report. Subset is based
     * on limit, offset and expanded groups.
     * This method is used when AgGrid is initialized in viewport mode.
     * @param reportId
     * @param limit
     * @param offset
     * @param expandedGroups
     * @param filter
     */

  }, {
    key: "getRowsData",
    value: function getRowsData(reportId, limit, offset, expandedGroups, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_WINDOW_PERFORMANCE_REPORT_COUNT_ROW_DATA(reportId)).post({
                  expandedGroups: expandedGroups,
                  limit: limit,
                  offset: offset,
                  filter: filter
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this2.windowPerformanceRowsDataDTOConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
    /**
     * Creates new promotion performance report
     * @param filter
     * @returns Promise<PromotionReportDTO>
     */

  }, {
    key: "renewReport",
    value: function renewReport(filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_PERFORMANCE_RENEW_REPORT).post(filter, {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
  }, {
    key: "getFilters",
    value: function getFilters(reportId, categories) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_PERFORMANCE_REPORT_FILTERS(reportId)).post({
                  categories: categories
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }]);

  return WindowPerformanceLayer;
}();

__decorate([Inject, __metadata("design:type", WindowPerformanceReportRowDTOConverter)], WindowPerformanceLayer.prototype, "windowPerformanceReportRowDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowPerformanceRowsDataDTOConverter)], WindowPerformanceLayer.prototype, "windowPerformanceRowsDataDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", GenericTreeReportHeaderConverter)], WindowPerformanceLayer.prototype, "genericTreeReportHeaderConverter", void 0);